import ShareWithLinkView from './ShareWithLinkView';

export default ShareWithLinkView;
